import type { ReactNode } from "react";
import { Tooltip } from "@/components/common/Tooltip";

// Standard ⓘ affordance: circled-i glyph triggering the shared Tooltip
// bubble, with an optional bold title line above the body. Always
// interactive so scrollable or selectable bubble content stays usable.
export function InfoTooltip({
  ariaLabel,
  title,
  children,
  placement = "top",
  className = "",
  contentClassName = "",
}: {
  ariaLabel: string;
  title?: ReactNode;
  children: ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
  className?: string;
  contentClassName?: string;
}) {
  return (
    <Tooltip
      placement={placement}
      className={className}
      contentClassName={contentClassName}
      interactive
      content={
        <span>
          {title != null ? <span className="block font-medium">{title}</span> : null}
          <span className={title != null ? "mt-1 block" : "block"}>{children}</span>
        </span>
      }
    >
      <span
        aria-label={ariaLabel}
        className="inline-flex cursor-help items-center text-ink/55 transition hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="h-4 w-4"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="11" x2="12" y2="16" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </span>
    </Tooltip>
  );
}
